import React from 'react';
import { I18n } from '@aws-amplify/core';

import DatePicker from '@/components/ui/DatePicker';
import FormItem from '@/components/ui/FormItem';
import { dateFormat } from '@/utils/date-format';

interface CollectDateFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

export function CollectDateFormItem({ required = true, fieldName }: Readonly<CollectDateFormItemProps>): JSX.Element {
	function disabledDate(current: moment.Moment) {
		return current && current.valueOf() >= Date.now();
	}

	return (
		<FormItem
			name={fieldName}
			label="Collection date"
			required={required}
			requiredMessage={I18n.get('The field requires an answer')}
		>
			<DatePicker
				placeholder={I18n.get('Collect date')}
				style={{ width: '100%' }}
				disabledDate={disabledDate}
				format={dateFormat()}
			/>
		</FormItem>
	);
}
